<script>
  import {getContext} from 'svelte';
  import {IMAGES} from '../images';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');
</script>

<style>
  .content {
    grid-gap: 0;
    display: grid;
    margin: 60px auto;
    height: 586px;
    grid-template-columns: 1fr 1fr;
  }
  .content > img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .text {
    box-sizing: border-box;
    padding: 60px 68px;
    width: 100%;
    font-size: 20px;
  }
  .img-filter {
    filter: brightness(50%);
  }
  @media screen and (max-width: 640px) {
    .content {
      margin-top: 40px;
      margin-bottom: 0;
      height: auto;
      grid-template-rows: 240px auto;
      grid-template-columns: 1fr;
    }
    .content > img {
      width: 100%;
    }
    .text {
      padding: 28px 24px;
      line-height: 20px;
      font-size: 14px;
      background: #1a1d1f;
    }
    .text img {
      height: 28px;
    }
    .text > div {
      margin-top: 12px;
      line-height: 18px;
      font-weight: 400;
      font-size: 12px;
    }
  }
</style>

<div class="content ovh">
  <img class="dib usn img-filter" src={IMAGES.UNIVERSITY} alt="cryptocurrency" />
  <div class="df fdc jcc aifs text">
    <img class="db usn" height="56px" src="https://img.phemex.com/v1/3ec44956-b5af-469f-9046-77aa793bc159/psl-log.svg" alt="dauphine university" />
    <div class="fw2 TW lh30 mt32">{LG(lang.OurDutyDesc)}</div>
  </div>
</div>
